import { createSlice } from "@reduxjs/toolkit";
import { Root } from "../models/Root";

const RootInitialState: {
	roots: Root[];
} = {
	roots: [],
};

export const RootReducer = createSlice({
	name: "__",
	initialState: RootInitialState,
	reducers: {
		setRoots(state, { payload }) {
			state.roots = payload;
		},
	},
});
